import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "month-filter-copy" }
const _hoisted_2 = { class: "month-filter-eyebrow" }
const _hoisted_3 = { class: "month-filter-controls" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['month-filter', _ctx.isDarkTheme ? 'theme-dark' : 'theme-light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.displayPeriod), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        value: _ctx.selectedMonth,
        class: "filter-select",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMonthChange && _ctx.handleMonthChange(...args)))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "Todos os meses", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
          return (_openBlock(), _createElementBlock("option", {
            key: month.value,
            value: month.value
          }, _toDisplayString(month.label), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4),
      _createElementVNode("select", {
        value: _ctx.selectedYear,
        class: "filter-select filter-select-year",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleYearChange && _ctx.handleYearChange(...args)))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "Todos os anos", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearOptions, (year) => {
          return (_openBlock(), _createElementBlock("option", {
            key: year,
            value: String(year)
          }, _toDisplayString(year), 9, _hoisted_7))
        }), 128))
      ], 40, _hoisted_6),
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "clear-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', '')))
          }, " Limpar "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}